export default __webpack_public_path__ + "static/3-c5816446f5dd7ae09855b36596a9be00.webp";